<template>
  <div id="app">
    <router-view/>
    <!-- <h1 v-if="isMobile">手机版页面</h1>
   <HomeView v-else></HomeView> -->
  </div>
</template>
<script>
import HomeView from './views/pcTerminal/HomeView.vue'
export default{
  components: { HomeView },
  data() {
    return {
      isMobile: false
    }
  },
  methods: {
    goPage() {
      if(this.isMobile){
        this.$router.push('/home-view-mobile')
      }
    },
    checkDevice() {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileKeywords = ['mobile', 'android', 'iphone', 'ipad', 'windows phone'];
      this.isMobile = mobileKeywords.some(keyword => userAgent.indexOf(keyword) !== -1);
      this.goPage()
    }
  },
  created(){
    this.checkDevice()
  }
}
</script>
<style lang="less">
  @import './assets/css/style.less';
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: #2c3e50;
  // .home_top{
  //   width: 100%;
  //   height: 100px;
  //   position: absolute;
  //   top: 0;
  //   z-index: 100;
  //   user-select: none;
  //   .home_top_text{
  //     width: 220px;
  //     height: 60px;
  //     display: flex;
  //     position: absolute;
  //     left: 200px;
  //     top: 20px;
  //     img{
  //       width: 60px;
  //       height: 60px;
  //     }
  //     div{
  //       width: 160px;
  //       height: 60px;
  //       font-size: 40px;
  //       font-family: HYYaKuHei, HYYaKuHei-700;
  //       font-weight: 700;
  //       text-align: LEFT;
  //       color: #ffffff;
  //       line-height: 60px
  //     }
  //   }
  //   .home_top_home{
  //     width: 400px;
  //     height: 60px;
  //     display: flex;
  //     color: #ffffff;
  //     position: absolute;
  //     right: 200px;
  //     top: 30px;
  //     justify-content: space-between;
  //     div{
  //       font-size: 20px;
  //       font-family: PingFang SC, PingFang SC-400;
  //       font-weight: 400;
  //       color: #ffffff;
  //       line-height: 40px;
  //     }
  //     div{
  //       position: relative;
  //       div{
  //         position: absolute;
  //         width: 40px;
  //         height: 4px;
  //         background: #ffffff;
  //         border-radius: 40px;
  //         bottom: 0px;
  //         left: 23%;
  //       }
  //     }
  //   }
  // }
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
